(ns dashboard.components.notification
  (:require
   [reagent.core :as reagent]
   [re-frame.core :as re-frame]
   [headlessui-reagent.core :as ui]
   [dashboard.utils :refer [cs]]
   [dashboard.i18n :refer [tr]]
   ["@heroicons/react/solid" :refer [XIcon CheckCircleIcon ExclamationIcon]]))

(defn notification
  [{:keys [is-open title message intent]
    :or {intent :intent/success}}]
  [:div.fixed.inset-0.flex.items-end.px-4.py-6.pointer-events-none.sm:p-6.sm:items-start.z-60
   {:aria-live "assertive"}
   [:div.w-full.flex.flex-col.items-center.space-y-4.sm:items-end
    [ui/transition
     {:show is-open
      :enter "transform ease-out duration-300 transition"
      :enter-from "translate-y-20 opacity-0 sm:translate-y-0 sm:translate-x-2"
      :enter-to "translate-y-12 opacity-100 sm:translate-x-0"
      :leave "transition ease-in duration-100"
      :leave-from "transform opacity-100"
      :leave-to "transform opacity-0"}
     [:div.max-w-sm.w-full.bg-white.shadow-lg.rounded-lg.pointer-events-auto.ring-1.ring-black.ring-opacity-5.overflow-hidden
      [:div.p-4
       [:div.flex.items-start
        [:div.flex-shrink-0
         (case intent
           :intent/success
           [:> CheckCircleIcon
            {:class "h-6 w-6 text-green-400"
             :aria-hidden true}]

           :intent/danger
           [:> ExclamationIcon
            {:class "h-6 w-6 text-red-400"
             :aria-hidden true}])]
        [:div.ml-3.flex-1.pt-0.5
         (when (some? title)
           [:p.text-sm.font-medium.text-gray-900
            title])
         (when (some? message)
           [:p.mt-1.text-sm.text-gray-500
            message])]
        [:div.ml-4.flex-shrink-0.flex
         [:button.bg-white.inline-flex.text-gray-400.hover:text-gray-500.rounded-md.focus:outline-none.focus:ring-2.focus:ring-offset-2.focus:ring-primary-500
          {:on-click #(re-frame/dispatch [:hide-notification])}
          [:span.sr-only
           (tr :action/close)]
          [:> XIcon
           {:class "h-5 w-5"
            :aria-hidden true}]]]]]]]]])
